﻿export async function getRefresh(instanceId: string | null): Promise<{ needsRefresh: boolean; instanceId: string | null }> {
    const url = new URL('/Refresh', window.location.origin);
    if (instanceId) {
        url.searchParams.set('instanceId', instanceId);
    }
    const requestInit: RequestInit = {
        method: 'GET',
        cache: 'no-cache',
        headers: {
            'cache': 'no-store',
            'cache-control': 'no-cache'
        }
    };
    const request = new Request(url, requestInit);
    const response = await fetch(request);
    switch (response.status) {
        case 200: {
            const payload = await parseResponse(response);
            return { instanceId: payload, needsRefresh: false };
        }
        case 205:
            return { instanceId: null, needsRefresh: true };
        default:
            throw new Error('Request to evaluate client instance failed');
    }
};
async function parseResponse(response: Response): Promise<string | null> {
    const instanceId = await response.json();
    if (typeof instanceId === 'string') {
        return instanceId;
    }
    return null;
}
